import { IChangeSettings } from '@/contracts/modules/education/use-case/IChangeSettings'
import { ISettings } from '@/contracts/modules/education/entities/ISettings'
import { ChangeSettingsRoute } from '@/modules/education/v1/api/v1/settings/ChangeSettings/ChangeSettingsRoute'
import { Settings } from '@/modules/education/v1/api/v1/settings/Dto/Settings'

export class ChangeSettings implements IChangeSettings {
  async exec(settings: ISettings): Promise<ISettings> {
    const response = await new ChangeSettingsRoute().exec(new Settings(settings))
    if (!response.isSuccess()) {
      throw new Error(response.getError())
    }
    return response.getData()
  }
}
